import { interpolate } from '@render-props/utils';
export default function scrollTo(element, from, to, _ref) {
  var duration = _ref.duration,
      timing = _ref.timing;
  var scroller = element === window ? window.scrollTo : function (x, y) {
    element.scrollTop = y;
    element.scrollLeft = x;
  };
  interpolate(function (values) {
    scroller(values.x, values.y);
  }, {
    from: from,
    to: to,
    duration: duration,
    timing: timing
  });
}